export type TokenPayload = {
  org_id?: number;
  org_roles?: string[];
  is_platform_admin?: boolean;
  exp?: number;
};

export type TokenPair = {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
};

/**
 * Terminal auth error codes returned by the backend auth API.
 * Must stay in sync with backend/app/core/errors/codes.py AuthErrorCodes.
 */
export const TERMINAL_AUTH_ERROR_CODES = [
  "auth_refresh_token_revoked",
  "auth_refresh_token_expired",
  "auth_refresh_token_not_found",
  "auth_account_suspended",
  "auth_membership_revoked",
] as const;

export type TerminalAuthErrorCode = (typeof TERMINAL_AUTH_ERROR_CODES)[number];
